import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 12l-10 0","key":"svg-0"}],["path",{"d":"M14 12l-4 4","key":"svg-1"}],["path",{"d":"M14 12l-4 -4","key":"svg-2"}],["path",{"d":"M20 4l0 16","key":"svg-3"}]]

const IconArrowBarToRight = createReactComponent('outline', 'arrow-bar-to-right', 'ArrowBarToRight', __iconNode);

export default IconArrowBarToRight;